import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import Applicant from "./Applicants";
import jwt_decode from "jwt-decode";
import { useDispatch } from "react-redux";
import { isLoading } from "../../../store/actions";

export default function ApplicantList(props) {
  const dispatch = useDispatch();
  const decode = jwt_decode(window.localStorage.getItem("accessToken"));

  const COMPANY_APPLICANTS_URL = `/applicant/list?page=${props.pageno}&limit=10`;
  const FROM_URL = `/applicant/first-application-date`;

  const [applicantsList, setApplicantsList] = useState([]);
  const [statusUpdate, setStatusUpdate] = useState(false);
  const [fromm, setFrom] = useState("");
  const [page, setPage] = useState();

  const From = async () => {
    const response = await axios.get(FROM_URL);
    var today = new Date(response.data.fromDate);
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = yyyy + "-" + mm + "-" + dd;
    setFrom(today);
  };

  useEffect(async () => {
    if (decode.role === "manager") {
      await getApplicants(COMPANY_APPLICANTS_URL, {
        role: decode.role,
        domain: decode.domain,
        filter: props.filter.filterstaus,
        propertyName: props.filter.propertyname,
        applicantName: props.filter.name,
        managerID: decode.id,
        applicantPhone: props.filter.phone,
        applicationStatus: props.filter.status,
        fromDate: props.filter.fromfilter,
        toDate: props.filter.tofilter,
        fromMoveIn: props.filter.fromMoveInfilter,
        toMoveIn: props.filter.toMoveInFilter,
        sorting: props.sorting,
        source: props.filter.source,
      });
    } else {
      await getApplicants(COMPANY_APPLICANTS_URL, {
        role: decode.role,
        domain: decode.domain,
        filter: props.filter.filterstaus,
        propertyName: props.filter.propertyname,
        applicantName: props.filter.name,
        applicantPhone: props.filter.phone,
        applicationStatus: props.filter.status,
        fromDate: props.filter.fromfilter,
        toDate: props.filter.tofilter,
        fromMoveIn: props.filter.fromMoveInfilter,
        toMoveIn: props.filter.toMoveInFilter,
        sorting: props.sorting,
        source: props.filter.source,
      });
    }
  }, [props.pageno, props.one, statusUpdate, props.sorting]);

  async function getApplicants(url, data) {
    try {
      dispatch(isLoading(true));
      const response = await axios.post(url, data);
      if (response.status === 200) {
        if (response.data.results.applications) {
          const temp = response.data.results.applications;
          setPage(
            response.data.results.previous
              ? response.data.results.previous.page + 1
              : 1
          );
          console.log(response.data.results.applications);
          setApplicantsList(temp);
          setStatusUpdate(false);
          props.totalap((prev) => ({
            ...prev,
            Total: response.data.total.Total || 0,
            Pending: response.data.total.Pending || 0,
            Approved: response.data.total.Approved || 0,
            Denied: response.data.total.Denied || 0,
          }));
        }
        dispatch(isLoading(false));
      } else {
        console.log("Unable to fetch the resoureces");
        dispatch(isLoading(false));
      }
    } catch (error) {
      console.log("unable to get applicants", error);
      dispatch(isLoading(false));
    }
  }

  useState(async () => {
    await From();

    if (decode.role === "company") {
      await getApplicants(COMPANY_APPLICANTS_URL, {
        role: decode.role,
        domain: decode.domain,
        // console.log('aniekt')
      });
    }

    if (decode.role === "manager") {
      await getApplicants(COMPANY_APPLICANTS_URL, {
        role: decode.role,
        managerID: decode.id,
      });
    }

    if (decode.role === "admin") {
      await getApplicants(COMPANY_APPLICANTS_URL, {
        role: decode.role,
      });
    }
  });

  let number = 0;
  let number1 = page > 1 ? (page - 1) * 10 : 0;
  props.filtrfrom(fromm);
  console.log(applicantsList[0]?.applicants[0]?.documents)
  return applicantsList?.map((applicant) => {
    number++;
    var today = new Date(applicant.createdAt);
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = dd + "-" + mm + "-" + yyyy;
    return (
      <Applicant
        number={number + number1}
        totalDocuments={applicant.totalDocuments}
        userID={decode.id}
        setStatusUpdate={setStatusUpdate}
        id={applicant._id}
        sources={applicant.main.source}
        status={applicant.status}
        propertyName={applicant.main.property}
        name={
          applicant.applicants[0].firstname +
          " " +
          applicant.applicants[0].lastname
        }
        email={applicant.applicants[0].email}
        mobile={applicant.applicants[0].phone}
        address={applicant.applicants[0].currentAddress}
        createdAt={today}
        getApplicants={() => getApplicants()}
        role={decode.role}
        documents={applicant?.documents}
        applicant_1_documents={applicant.applicants[0]?.documents}
        applicant_2_documents={applicant.applicants[1]?.documents}
        date={applicant.main.date}
        leaseDocument={applicant.leaseDocument}
      />
    );
  });
}
